const prod = {
    url: {
        API_URL: process.env.REACT_APP_API_URL
    },
};

const dev = {
    url: {
        API_URL: process.env.REACT_APP_API_URL,
    },
};

class API {
    constructor() {
        this.config = process && process.env.NODE_ENV === 'development' ? dev : prod;
    }

    health() {
        return `${this.config.url.API_URL}/api/v2/health`
    }

    auth() {
        return `${this.config.url.API_URL}/api/v2/auth/token`;
    }

    authType(username) {
        return `${this.config.url.API_URL}/api/v2/auth/type?email=${username}`;
    }

    registerLinkedAccount() {
        return `${this.config.url.API_URL}/api/v2/auth/link`;
    }

    logout() {
        return `${this.config.url.API_URL}/api/v2/auth/logout`;
    }

    me() {
        return `${this.config.url.API_URL}/api/v2/auth/me`;
    }

    refresh() {
        return `${this.config.url.API_URL}/api/v2/auth/refresh`;
    }
}

export const api = new API();
